import { Button } from "antd";
import { DownloadIcon } from "../icons/DownloadIcon";

export const ExportDataButton = ({ onClick, disabled }) => (
  <Button
    style={{ display: "flex", alignItems: "center" }}
    type="primary"
    onClick={onClick}
    disabled={disabled}
    icon={<DownloadIcon style={{ display: "flex", fontSize: "14px" }} />}
  >
    Export
  </Button>
);
